import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProjectImageCard from "./components/projectImageCard/projectImageCard";
import DetailsSection from "./components/detailsSection/detailsSection";
import ActiveNotificationBanner from "../../notifications/components/activeNotificationBanner/activeNotificationBanner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PublicView = ({ collapsed, setCollapsed }) => {
  const { projectId } = useParams();
  const [project, setProject] = useState(null);
  const [ownerEmail, setOwnerEmail] = useState(null);
  const [openRoles, setOpenRoles] = useState([]);
  const [ownerProfileImage, setOwnerProfileImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeNoti, setActiveNoti] = useState(null);
  const [toastAlerts, setToastAlerts] = useState(true);

  useEffect(() => {
    const fetchProjectDetails = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/projects/${projectId}/details`);
        const data = await res.json();
        setProject(data.project);
        setOwnerEmail(data.project?.owner);
        fetchOwnerProfileImage(data.project?.owner);
        fetchOpenRoles();
      } catch (e) {
        console.error("❌ Project fetch failed:", e);
      } finally {
        setLoading(false);
      }
    };

    const fetchOwnerProfileImage = async (email) => {
      if (!email) return;
      const encoded = encodeURIComponent(email);
      const res = await fetch(`${BACKEND_URL}/user/${encoded}/profile-image`);
      const data = await res.json();
      if (res.ok && data.profileImage) setOwnerProfileImage(data.profileImage);
    };

    const fetchOpenRoles = async () => {
      const res = await fetch(`${BACKEND_URL}/applications/${projectId}/open-roles`);
      const data = await res.json();
      if (res.ok) {
        const roles = (data.openRoles || []).filter((r) => r.status !== "closed");
        setOpenRoles(roles);
      }
    };

    fetchProjectDetails();
  }, [projectId]);

  useEffect(() => {
    const fetchToastPreference = async () => {
      const token = localStorage.getItem("token");
      if (!token) return;
      const res = await fetch(`${BACKEND_URL}/user/preferences`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok && data.preferences) {
        setToastAlerts(data.preferences.toastAlerts);
      }
    };
    fetchToastPreference();
  }, []);

  if (loading) return <p className="p-6">Loading project details...</p>;
  if (!project) return <p className="p-6 text-red-500">Project not found.</p>;

  return (
  <div className="min-h-screen w-full bg-gray-50 pt-[90px] pb-10 overflow-x-hidden">
    {toastAlerts && activeNoti && (
      <ActiveNotificationBanner
        notification={activeNoti}
        onClose={() => setActiveNoti(null)}
      />
    )}

    <div className="max-w-screen-lg mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row gap-6">
      {/* Left: Image */}
      <div className="w-full lg:w-1/2">
        <ProjectImageCard image={`${project.image}?v=${Date.now()}`} title={project.title} />
      </div>

      {/* Right: Details */}
      <div className="w-full lg:w-1/2">
        <DetailsSection
          project={project}
          openRoles={openRoles}
          ownerEmail={ownerEmail}
          ownerProfileImage={ownerProfileImage}
        />
      </div>
    </div>
  </div>
);

};

export default PublicView;
